let mixins
// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  mixins = {
    computed: {
      itemid() { return this.item.id },
      title() { return this.item.name },
      headerContent() { return this.item.headerContent.content },
      headerLinks() { return this.item.headerContent.links.filter(l => l.url) },
      headerImage() {
        // TODO: check for filestore and if set then generate a presigned URL as required.
        return {
          title: this.item.headerContent.title,
          alt: this.item.headerContent.alt,
          url: this.item.headerContent.url
        }
      },
      headerClasses() {
        return this.headerPosition + ' ' + ((this.hasImage) ? 'has-image' : '')
      },
      hasImage() {
        return this.headerImage
      }
    },
    methods: {
    }
  }
}
else {
  mixins = {
    computed: {
      itemid() { return this.item.nid },
      title() { return this.item.title },
      headerContent() {
        return this.item.field_t_content_header_content
      },
      headerLinks() {
        return this.item.field_l_content_header_links.filter(l => l.url)
      },
      headerImage() {
        return this.item.field_f_content_header_img
      },
      headerClasses() {
        return this.headerPosition + ' ' + ((this.hasImage) ? 'has-image' : '')
      },
      hasImage: function() {
        return (this.item.field_f_content_header_img && this.item.field_f_content_header_img.filepath)
      }
    }
  }
}

export default mixins
